module.exports = __webpack_public_path__ + "static/kuromitsu_ka-08a0ec6a34471bee1aeb72debd494b75.jpg";